import { useState, useEffect, lazy, Suspense, useCallback } from "react";
import HeroBanner from "./components/HeroBanner";
import IntroSection from "./components/IntroSection";
import TemplateSection from "./components/TemplateSection";
import SEO from "./components/SEO";
import { Box } from "@mui/material";
import "./App.css";
import { TEMPLATES } from "./components/templates";
import { useNavigate } from "react-router-dom";

/* ================== Lazy Loading ================== */

const StepsSection = lazy(() => import("./components/StepsSection"));
const SeoMicrocopySection = lazy(() => import("./components/SeoMicrocopySection"));
const WhyChooseUs = lazy(() => import("./components/WhyChooseUs"));
const LanguageSupportSection = lazy(() => import("./components/LanguageSupportSection"));
const UseCaseSection = lazy(() => import("./components/UseCaseSection"));
const BackgroundTemplateSelector = lazy(() =>
  import("./components/BackgroundTemplateSelector")
);
const RelevantTopics = lazy(() => import("./components/RelevantTopics"));
const FaqSection = lazy(() => import("./components/FaqSection"));

function AppMain() {
  const navigate = useNavigate();

  /* ================== STATE ================== */

  const DEFAULT_TEMPLATE = TEMPLATES[0]?.value;
  const [selectedBg, setSelectedBg] = useState(DEFAULT_TEMPLATE);

  /* ================== EFFECT ================== */

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* ================== HANDLERS ================== */

  const handleTemplateSelect = useCallback(
    (template) => {
      if (!template) return;

      navigate("/create-biodata", {
        state: {
          selectedBg: template.value,
          theme: template.theme,
        },
      });
    },
    [navigate]
  );

  /* ================== RENDER ================== */

  return (
    <>
      <SEO
        title="Create Marriage Biodata Online for Free | MarriageBiodata.live"
        description="Create marriage biodata online for free with beautiful templates. No signup required. Download PDF instantly in Marathi, Hindi, or English."
        canonical="https://www.marriagebiodata.live/"
      />

      <Box display="flex" flexDirection="column">
        {/* ✅ ABOVE THE FOLD (FAST LOAD) */}
        <IntroSection />
        <HeroBanner />
        <TemplateSection />

        {/* ✅ BELOW THE FOLD (LAZY LOADED) */}
        <Suspense fallback={<div style={{ height: 200 }} />}>
          <StepsSection />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <WhyChooseUs />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <LanguageSupportSection />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <UseCaseSection />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <SeoMicrocopySection />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <BackgroundTemplateSelector
            title="Popular Templates"
            templates={TEMPLATES.filter((t) => t.category === "popular")}
            selectedBg={selectedBg}
            onSelect={handleTemplateSelect}
            showSeeMore={true}
            enablePreview
            subtitle="Preview some of the sample Marriage Biodata. Click on biodata to Preview."
          />
        </Suspense>

        <Suspense fallback={<div style={{ height: 200 }} />}>
          <RelevantTopics />
        </Suspense>
        
        <Suspense fallback={<div style={{ height: 200 }} />}>
          <FaqSection />
        </Suspense>    
      </Box>
    </>
  );
}

export default AppMain;